import { roundQuantity } from "../../../ExportExcelButtonV3/utils";
import type { QuantityColumnValueOf } from "./types";

export const quantityColumnValueOf: QuantityColumnValueOf = ({
  row,
  quantityColumn,
}) => {
  if (row.kind === "section") return "";
  const quantity = roundQuantity(
    quantityColumn.floorPlanIds.reduce(
      (sum, floorPlanId) => sum + (row.planValues[floorPlanId] ?? 0),
      0,
    ),
  );
  // A column without this position stays visually empty, like the Excel sheet
  return quantity === 0 ? "" : quantity;
};
